// GpxFix Map Module
// Provides map initialization and track editing functionality
(function () {
    'use strict';
    //// Global state variables
    var slidersSyncByTime = false;
    var slidersSyncByIndex = false;
    var sliderSyncByRelative = false;
    var sliderSyncEvenHandlersAdded = false;
    var sliderSyncByIndexOffsetAtLockingTime = 0;
    var isMouseDown = false;   
    var allowedEdits = 50;
    var editsLeft = allowedEdits;
    var maxDistance = 0;
    var maxPair = [];
    var movingPoints = 0;
    var totalDistance = 0;
    var distances = [];
    var maxAllowedDist = 0;
      

    function updateSliderLockState() {
        const isLocked = slidersSyncByTime || slidersSyncByIndex || sliderSyncByRelative;
        const element = $('#lockSymbol');

        if (isLocked) {
            element.html('🔒');
            $("#compare-slider-2").prop("disabled", true);
        } else {
            element.html('&nbsp;');
            $("#compare-slider-2").prop("disabled", false);
        }
    }

    function getMarkerByIndex(polyl, index) {
        const latlngs = polyl.getLatLngs();
        const targetLatLng = latlngs[index];
        let result = null;

        polyl.editor.editLayer.eachLayer(layer => {
            if (!(layer instanceof L.Marker)) return;
            const m = layer.getLatLng();
            if (Math.abs(m.lat - targetLatLng.lat) < 1e-6 && Math.abs(m.lng - targetLatLng.lng) < 1e-6) {
                result = layer;
            }
        });
        return result;
    }

    function findClosestIndexByTime(trackPointDataset, targetTime) {
        if (!trackPointDataset || trackPointDataset.length === 0) return 0;

        const targetTimestamp = Date.parse(targetTime);
        if (isNaN(targetTimestamp)) return 0;

        let closestIndex = 0;
        let minDiff = Math.abs(Date.parse(trackPointDataset[0][2]) - targetTimestamp);

        for (let i = 1; i < trackPointDataset.length; i++) {
            const currentTimestamp = Date.parse(trackPointDataset[i][2]);
            const diff = Math.abs(currentTimestamp - targetTimestamp);
            if (diff < minDiff) {
                minDiff = diff;
                closestIndex = i;
            }
        }
        return closestIndex;
    }

    function addSliderSyncEventHandlersIfNotAdded() {
        if ($("#compare-slider-2").length > 0 && !sliderSyncEvenHandlersAdded) {
            $(document)
                .on("mousedown", function () { isMouseDown = true; })
                .on("mouseup", function () { isMouseDown = false; });

            $("#compare-slider-1").on("input", function () {
                const slider1Index = parseInt($("#compare-slider-1").val());
                displayCompareSliderPositionData(1, slider1Index, window.gpxFixState.coordinates);

                if (slidersSyncByTime && isMouseDown) {
                    const currentTime = window.gpxFixState.coordinates[slider1Index][2];
                    const slider2Index = findClosestIndexByTime(window.gpxFixState.compareState.coordinates, currentTime);
                    $("#compare-slider-2").val(slider2Index);
                    displayCompareSliderPositionData(2, slider2Index, window.gpxFixState.compareState.coordinates);
                } else if (slidersSyncByIndex && isMouseDown) {
                    const slider2Index = slider1Index + sliderSyncByIndexOffsetAtLockingTime;
                    $("#compare-slider-2").val(slider2Index);
                    displayCompareSliderPositionData(2, slider2Index, window.gpxFixState.compareState.coordinates);
                } else if (sliderSyncByRelative && isMouseDown) {
                    const slider1Max = parseInt($("#compare-slider-1").attr('max'));
                    const slider2Max = parseInt($("#compare-slider-2").attr('max'));
                    const slider1RelativePosition = slider1Index / slider1Max;
                    const slider2RelativePosition = slider1RelativePosition;
                    const slider2Index = Math.round(slider2RelativePosition * slider2Max);
                    const clampedSlider2Index = Math.max(0, Math.min(slider2Index, slider2Max));                    
                    $("#compare-slider-2").val(clampedSlider2Index);
                    displayCompareSliderPositionData(2, clampedSlider2Index, window.gpxFixState.compareState.coordinates);
                }
            });

            $("#compare-slider-2").on("input", function () {
                const slider2Index = parseInt($("#compare-slider-2").val());                
                displayCompareSliderPositionData(2, slider2Index, window.gpxFixState.compareState.coordinates);
            });
            sliderSyncEvenHandlersAdded = true;
            displayCompareSliderPositionData(1, 0, window.gpxFixState.coordinates);
            displayCompareSliderPositionData(2, 0, window.gpxFixState.compareState.coordinates);
        }
    }

    function syncSlidersByTime() {
        slidersSyncByTime = true;
        slidersSyncByIndex = false;
        sliderSyncByRelative = false;
        $("#chkLockSlidersPoint").prop("checked", false);
        $("#chkLockSlidersRelative").prop("checked", false);
        updateSliderLockState();
        addSliderSyncEventHandlersIfNotAdded();
    }

    function syncSlidersByIndex() {
        slidersSyncByIndex = true;
        slidersSyncByTime = false;
        sliderSyncByRelative = false;
        const slider1Index = parseInt($("#compare-slider-1").val());
        const slider2Index = parseInt($("#compare-slider-2").val());
        sliderSyncByIndexOffsetAtLockingTime = slider2Index - slider1Index;
        $("#chkLockSlidersTime").prop("checked", false);
        $("#chkLockSlidersRelative").prop("checked", false);        
        updateSliderLockState();
        addSliderSyncEventHandlersIfNotAdded();
    }

    function syncSlidersByRelativeRange() {
        slidersSyncByIndex = false;
        slidersSyncByTime = false;
        sliderSyncByRelative = true;
        $("#chkLockSlidersTime").prop("checked", false);
        $("#chkLockSlidersPoint").prop("checked", false);
        updateSliderLockState();
        addSliderSyncEventHandlersIfNotAdded();
    }

    function displayCompareSliderPositionData(sliderId, idx, trackPointDataset) {        
        idx = Math.max(0, Math.min(idx, trackPointDataset.length - 1));
        var timeAtStart = Date.parse(trackPointDataset[0][2]);
        var timeAtSlider = Date.parse(trackPointDataset[idx][2]);
        var hr = trackPointDataset[idx][1];
        var ele = trackPointDataset[idx][3];
        var speed = trackPointDataset[idx][4];
        var cad = trackPointDataset[idx][5];
        var power = trackPointDataset[idx][6];

        const localStartTimeAtActivity = addHours(new Date(timeAtStart), window.gpxFixState.compareState.summary.timezoneOffsetActivityLocation);
        const startTimeAtActivityBrowserAdjusted = addHours(localStartTimeAtActivity, browserTimezoneOffset);

        let localTimeAtActivity = addHours(new Date(timeAtSlider), window.gpxFixState.compareState.summary.timezoneOffsetActivityLocation);
        let timeAtActivityBrowserAdjusted = addHours(localTimeAtActivity, browserTimezoneOffset);
        if (timeAtStart == null) {
            localTimeAtActivity = null;
            timeAtActivityBrowserAdjusted = null;
        }

        let info = formatPointPreviewInfo(idx, trackPointDataset.length, startTimeAtActivityBrowserAdjusted, timeAtActivityBrowserAdjusted,
            hr, ele, speed, cad, power, trackPointDataset[idx][7]);

        $('#mapOutput' + sliderId).html(info);

        if (sliderId == '1') {
            var data = window.gpxFixState.compareOrigLatLng1[idx];
            window.gpxFixState[`compareMarker${sliderId}`].setLatLng([data.lat, data.lng]);
        } else {
            var data = window.gpxFixState.compareOrigLatLng2[idx];
            window.gpxFixState[`compareMarker${sliderId}`].setLatLng([data.lat, data.lng]);
        }

        moveVerticalLineTo(sliderId, idx);
    }


    function setEditCoordinateLimits() {
        // Calculate distance metrics
        //debug('setEditCoordinateLimits state=');
        debug(window.gpxFixState);
        //debug(window.gpxFixState.gpxXml);

        // Reset accumulators so repeated calls (e.g. after edits/deletions) don't compound stale state
        totalDistance = 0;
        movingPoints = 0;
        maxDistance = 0;
        maxPair = [];
        distances = [];

        const origCoords = window.gpxFixState.origLatLngs;
        if (!origCoords || origCoords.length < 2) {
            maxAllowedDist = 0;
            return;
        }

        for (let i = 0; i < origCoords.length - 1; i++) {
            const dist = origCoords[i].distanceTo(origCoords[i + 1]);
            if (dist > 0.2 && dist < 1000) {
                totalDistance += dist;
                distances.push(dist);
                movingPoints++;
                if (dist > maxDistance) {
                    maxDistance = dist;
                    maxPair = [origCoords[i], origCoords[i + 1]];
                }
            }
        }

        if (movingPoints === 0) {
            maxAllowedDist = 0;
            return;
        }

        // In-place sort (no copy needed - distances is local accumulator)
        distances.sort((a, b) => a - b);
        const mid = Math.floor(distances.length / 2);
        const medianDistance = distances.length % 2 === 0
            ? (distances[mid - 1] + distances[mid]) / 2
            : distances[mid];
        const averageDistance = totalDistance / movingPoints;
        maxAllowedDist = Math.min(medianDistance, averageDistance) * 2;
    }

    function hasCoordinatesEditError() {
        var polyline = window.gpxFixState && window.gpxFixState.polyline;
        if (!polyline) 
            return false;        

        let latlngs = polyline.getLatLngs();
        if (!latlngs || latlngs.length === 0) {
            return false;
        }

        if (!window.gpxFixState.edits) {
            debug('No edits');
            return false;
        }

        for (let i = 0; i < window.gpxFixState.edits.length; i++) {
            if (window.gpxFixState.edits[i].action === 'delete') {
                continue;
            }

            let idx = parseInt(window.gpxFixState.edits[i].index);
            if (isNaN(idx) || idx < 0 || idx >= latlngs.length) {
                continue;
            }

            let idxNext = idx + 1;            
            let editedCoord = latlngs[idx];
            if (idxNext >= latlngs.length)
                idxNext = latlngs.length - 1;
            let nextCoord = latlngs[idxNext];
            if (!editedCoord || !nextCoord || typeof editedCoord.distanceTo !== 'function') {
                continue;
            }

            let dist = editedCoord.distanceTo(nextCoord);
            if (dist > maxAllowedDist*10) {
                // $('#msgBottom').html('<p class=\'error\'>Distance between points is too large. See red markers. This indicates an unrealistic movement. Please reduce the distance between each modified coordinates.</p>').show().delay(12000).fadeOut('slow');
                const marker = getMarkerByIndex(polyline, idx);
                //console.log('distance too far :indexes:' + idx + '-' + idxNext + ' dist:' + dist + ' maxalloweddist:' + maxAllowedDist);
                if (marker) {
                    marker.getElement().classList.add('highlight-marker');
                    const marker2 = getMarkerByIndex(polyline, idxNext);
                    if (marker2) {
                        marker2.getElement().classList.add('highlight-marker');
                        return true;
                    }
                }
            }
        }
        return false;
    }

    function attachDragListeners() {
        // Get polyline reference at call time, not at module load time
        var polyline = window.gpxFixState && window.gpxFixState.polyline;
        
        // Ensure polyline exists before attaching listeners
        if (!polyline) {
            console.warn('Polyline not initialized. Cannot attach drag listeners.');
            return;
        }

        polyline.on('editable:vertex:dragend', function (e) {
            const latlngs = polyline.getLatLngs();
            const coord = e.vertex.getLatLng();
            const marker = e.vertex;

            const i = latlngs.findIndex(latlng => latlng.equals(coord));

            if (marker._origLatLng === undefined) {
                attachDragListeners();
                return;
            }

            if (marker._origLatLng && (coord.lat !== marker._origLatLng.lat || coord.lng !== marker._origLatLng.lng)) {
                const dist = coord.distanceTo(marker._origLatLng);
                const iInEdits = window.gpxFixState.edits.find(edit => edit.index === i);

                if (editsLeft <= 0 && !iInEdits && window.gpxFixState.hasTimeCodes) {
                    showError('Sorry. To prevent cheating we do not allow editing unlimited coordinates.');
                    marker.setLatLng(marker._origLatLng);
                    latlngs[i].lng = marker._origLatLng.lng;
                    latlngs[i].lat = marker._origLatLng.lat;
                    polyline.redraw();
                    return;
                }

                if (dist > maxAllowedDist && window.gpxFixState.hasTimeCodes) {
                    showMessage('Warning. The distance to the next point was ' + dist.toFixed(1) + ' meters which is more than the allowed ' + maxAllowedDist.toFixed(1) + ' meters.','To prevent cheating this must the fixed before you submitting the changes.');
                } else {
                    showError('');
                }

                const existingEdit = window.gpxFixState.edits.find(edit => edit.index === i);
                if (existingEdit) {
                    existingEdit.latlng = { lat: latlngs[i].lat, lng: latlngs[i].lng };
                } else {
                    window.gpxFixState.edits.push({
                        index: i,
                        lat: latlngs[i].lat,
                        lng: latlngs[i].lng
                    });
                }

                $('#panel-submit-edits').show();
                if (window.gpxFixState.hasTimeCodes) {
                    editsLeft = allowedEdits - window.gpxFixState.edits.length;
                    $('#changesLeft').text(editsLeft + ' coordinates for editing left. To prevent cheating and misuse we do not allow editing more than ' + allowedEdits + ' coordinates for activities that have time data. Avoid restrictions by first using the Strip-feature which will remove timestamps. Right-click with the mouse on a point to delete a point.');
                }
            }
        });

        polyline.editor.editLayer.eachLayer(function (marker) {
            if (!(marker instanceof L.Marker)) return;

            if (!marker._dragEventsAttached) {
                marker._dragEventsAttached = true;
                marker.on('dragstart', function () {
                    marker._origLatLng = marker.getLatLng().clone();
                });
                marker.off('click');
                marker.on('click', function (e) {
                    e.originalEvent.preventDefault();
                    e.originalEvent.stopPropagation();
                    return false;
                });
            }
        });
    }

    function detachDragListeners() {
        var polyline = window.gpxFixState && window.gpxFixState.polyline;
        if (polyline) {
            polyline.off('editable:vertex:dragend');
        }
    }

    $(document).ready(function () {
        // Setup slider sync checkboxes
        $("#chkLockSlidersTime").on("change", function () {
            if (this.checked) {
                syncSlidersByTime();
            } else {
                slidersSyncByTime = false;
                updateSliderLockState();
            }
        });

        $("#chkLockSlidersPoint").on("change", function () {
            debug('adding listener chkLockSlidersPoint')
            if (this.checked) {
                syncSlidersByIndex();
            } else {
                slidersSyncByIndex = false;
                updateSliderLockState();
            }
        });

        $("#chkLockSlidersRelative").on("change", function () {
            if (this.checked) {
                syncSlidersByRelativeRange();
            } else {
                sliderSyncByRelative = false;
                updateSliderLockState();
            }
        });        

    });

    /**
     * Move vertical line on chart to specified index
     * Uses shared chart utility if available
     * @param {number} chartId - Chart identifier (1 or 2)
     * @param {number} idx - Index position to move line to
     */
    function moveVerticalLineTo(chartId, idx) {
        // Use shared chart utility if available
        if (window.GpxFixChart && window.GpxFixChart.moveVerticalLineTo) {
            var chartEl = document.getElementById('compare-chart-' + chartId) || document.getElementById('chart' + chartId);
            if (chartEl && chartEl._chart) {
                window.GpxFixChart.moveVerticalLineTo(chartEl._chart, idx);
                return;
            }
        }

        // Fallback - direct Chart.js access
        var chartCanvasId = document.getElementById('compare-chart-' + chartId) ? 'compare-chart-' + chartId : 'chart' + chartId;
        var chartCanvas = document.getElementById(chartCanvasId);
        if (chartCanvas) {
            var chartInstance = Chart.getChart(chartCanvasId);
            if (chartInstance && chartInstance.options && chartInstance.options.plugins) {
                chartInstance.options.plugins.verticalLine.xValue = idx;
                chartInstance.draw();
            }
        }
    }

    /**
     * Find the index of the nearest track point to a Leaflet LatLng.
     * @param {L.LatLng} clickedLatLng
     * @param {Array} latlngs - array of L.LatLng (from polyline.getLatLngs())
     * @returns {number} nearest index, or -1 if none found
     */
    function findNearestTrackIndex(clickedLatLng, latlngs) {
        if (!clickedLatLng || !latlngs || latlngs.length === 0) return -1;
        var nearestIdx = -1;
        var minDist = Infinity;
        for (var i = 0; i < latlngs.length; i++) {
            var ll = latlngs[i];
            if (!ll || typeof ll.distanceTo !== 'function') continue;
            var dist = clickedLatLng.distanceTo(ll);
            if (dist < minDist) {
                minDist = dist;
                nearestIdx = i;
            }
        }
        return nearestIdx;
    }

    // Export functions globally for external use
    window.GpxFixMap = window.GpxFixMap || {};
    window.GpxFixMap.setEditCoordinateLimits = setEditCoordinateLimits;  
    window.GpxFixMap.attachDragListeners = attachDragListeners;
    window.GpxFixMap.detachDragListeners = detachDragListeners;
    window.GpxFixMap.displaySliderPositionData = displayCompareSliderPositionData;
    window.GpxFixMap.findClosestIndexByTime = findClosestIndexByTime;
    window.GpxFixMap.findNearestTrackIndex = findNearestTrackIndex;
    window.GpxFixMap.syncSlidersByTime = syncSlidersByTime;
    window.GpxFixMap.syncSlidersByIndex = syncSlidersByIndex;
    window.GpxFixMap.syncSlidersByRelativeRange = syncSlidersByRelativeRange;
    window.GpxFixMap.hasCoordinatesEditError = hasCoordinatesEditError;
    window.GpxFixMap.addSliderSyncEventHandlersIfNotAdded = addSliderSyncEventHandlersIfNotAdded;

})();

// ---- Shared waypoint helpers ----
(function (mod) {
    mod.makeWaypointIcon = function (zoom) {
        var size = zoom >= 16 ? 18 : zoom >= 13 ? 14 : 11;
        return L.divIcon({
            className: 'red-marker',
            html: '<div style="background-color: #0D5578; width: ' + size + 'px; height: ' + size + 'px; border-radius: 50%;"></div>',
            iconSize: [size, size],
            iconAnchor: [size / 2, size / 2]
        });
    };

    // Generates popup HTML content for a waypoint including images from links
    mod.buildWaypointPopupContent = function (wpt) {
        var popupContent = '';
        if (wpt.name) {
            popupContent += '<b>' + wpt.name + '</b><br>';
        }
        if (wpt.desc) {
            popupContent += wpt.desc + '<br>';
        }

        // Add images from links if available
        if (wpt.links && wpt.links.length > 0) {
            wpt.links.forEach(function (link) {
                // Check if link type indicates an image
                if (link.type && link.type.toLowerCase().startsWith('image/')) {
                    popupContent += '<img src="' + link.href + '" alt="' + (link.text || 'Image') + '" />';
                    if (link.text) {
                        popupContent += '<small>' + link.text + '</small><br>';
                    }
                } else if (link.href) {
                    // For non-image links, show as clickable link
                    popupContent += '<a href="' + link.href + '" target="_blank">' + (link.text || link.href) + '</a><br>';
                }
            });
        }

        return popupContent;
    };

    // Renders waypoint markers onto map. Returns array of markers.
    // Attaches a zoomend listener that resizes the markers automatically.
    mod.renderWaypointMarkers = function (map, waypoints) {
        var markers = [];
        if (!waypoints || waypoints.length === 0) return markers;
        var icon = mod.makeWaypointIcon(map.getZoom());
        waypoints.forEach(function (wpt) {
            var marker = L.marker([wpt.lat, wpt.lon], { icon: icon }).addTo(map);

            // Build popup content using helper function
            var popupContent = mod.buildWaypointPopupContent(wpt);

            // Only bind popup if there's content to display
            if (popupContent) {
                marker.bindPopup(popupContent);
                // Open popup on hover so details are visible without clicking
                marker.on('mouseover', function () { marker.openPopup(); });
                marker.on('mouseout', function () { marker.closePopup(); });
            }

            markers.push(marker);
        });
        map.on('zoomend', function () {
            var newIcon = mod.makeWaypointIcon(map.getZoom());
            markers.forEach(function (m) { m.setIcon(newIcon); });
        });
        return markers;
    };
}(window.GpxFixMap = window.GpxFixMap || {}));
// Add removeTrackPoint utility for deleting a coordinate from the current track
window.GpxFixMap = window.GpxFixMap || {};
(function (mod) {
    // Remove a track point at given index. Returns true if removed.
    mod.removeTrackPoint = function (index) {
        try {
            const state = window.gpxFixState;
            if (!state || !state.map || !state.polyline || !state.coordinates) return false;
            index = parseInt(index);
            if (isNaN(index) || index < 0 || index >= state.coordinates.length) return false;

            // Remove from coordinates array
            state.coordinates.splice(index, 1);

            // Remove point from polyline and re-add
            const latlngs = state.polyline.getLatLngs();
            if (index >= 0 && index < latlngs.length) {
                latlngs.splice(index, 1);
            }

            // Remove old polyline layer
            try { state.map.removeLayer(state.polyline); } catch (e) { /* ignore */ }

            // Add new polyline
            state.polyline = L.polyline(latlngs, { color: '#dc2b00', weight: 3 }).addTo(state.map);

            // Update original latlngs
            state.origLatLngs = state.polyline.getLatLngs().map(latlng => L.latLng(latlng.lat, latlng.lng));

            // Update marker to first point or remove
            if (state.marker) {
                if (state.coordinates && state.coordinates.length > 0 && state.coordinates[0] && state.coordinates[0][0]) {
                    state.marker.setLatLng([state.coordinates[0][0].lat, state.coordinates[0][0].lon]);
                } else {
                    try { state.map.removeLayer(state.marker); } catch (e) { }
                    state.marker = null;
                }
            }

            // Update waypoints bounds and markers if needed
            if (state.waypointMarkers && state.waypointMarkers.length > 0) {
                state.waypointMarkers.forEach(m => {
                    try { m.remove(); } catch (e) { }
                });
                state.waypointMarkers = [];
            }

            // Record edit for submission
            state.edits = state.edits || [];
            state.edits.push({ action: 'delete', index: index });

            // Update slider max
            const $slider = $('#timeSlider');
            if ($slider && $slider.length) {
                $slider.attr('max', Math.max(0, (state.coordinates.length - 1)));
                const val = Math.min(parseInt($slider.val() || 0), Math.max(0, (state.coordinates.length - 1)));
                $slider.val(val);
            }

            // Trigger any helper updates
            if (mod.setEditCoordinateLimits) mod.setEditCoordinateLimits();

            return true;
        } catch (e) {
            console.error('removeTrackPoint error', e);
            return false;
        }
    };

})(window.GpxFixMap);

// ---- Spike-zone warning marker helpers ----
// Renders warning markers on the map at GPS spike zone locations.
// Spike zones are areas where the GPS signal was erratic — typically when the user
// went indoors or under heavy tree cover while the device was still recording.
(function (mod) {

    /**
     * Create a Leaflet DivIcon that shows a warning symbol (⚠️) scaled by severity.
     * Higher severity produces a slightly larger icon to attract more attention.
     * @param {number} severity - Value between 0 and 1 indicating how bad the spike zone is.
     * @returns {L.DivIcon}
     */
    function makeSpikeZoneIcon(severity) {
        // Scale font size between 18 px (low severity) and 26 px (high severity)
        var fontSize = Math.round(18 + severity * 8);
        return L.divIcon({
            className: 'spike-zone-marker',
            // The ⚠ character renders as a coloured warning triangle in all modern browsers.
            html: '<div style="font-size:' + fontSize + 'px;line-height:1;filter:drop-shadow(0 1px 2px rgba(0,0,0,0.6));">⚠️</div>',
            iconSize: [fontSize + 4, fontSize + 4],
            iconAnchor: [(fontSize + 4) / 2, (fontSize + 4) / 2]
        });
    }

    /**
     * Build a human-readable popup description for a spike zone.
     * @param {Object} zone - Spike zone object from the API { lat, lon, r, sev, s, e }
     * @returns {string} HTML string for the Leaflet popup.
     */
    function buildSpikeZonePopup(zone) {
        var severityText = zone.sev >= 0.9 ? 'severe' : zone.sev >= 0.6 ? 'moderate' : 'mild';
        var pointRange = 'track points ' + zone.s + '–' + zone.e;
        return '<b>⚠️ GPS spike zone detected</b><br>' +
               'The GPS signal was erratic here — this typically happens when you went indoors ' +
               'or the device lost satellite lock while still recording.<br>' +
               '<small>Severity: <b>' + severityText + '</b> (' + (zone.sev * 100).toFixed(0) + '%) · ' +
               'Radius ~' + zone.r + ' m · ' + pointRange + '</small>';
    }

    /**
     * Renders spike-zone warning markers onto the given Leaflet map.
     * Existing spike-zone markers are removed before new ones are added so
     * this function is safe to call multiple times (e.g. after reloading a file).
     *
     * @param {L.Map} map - The Leaflet map instance to render onto.
     * @param {Array} zones - Array of spike zone objects from the API response.
     *                        Each object has: lat, lon, r (radius m), sev (0-1), s (startIdx), e (endIdx).
     * @param {Array} existingMarkers - Array of previously added spike zone markers to remove first.
     * @returns {Array} The newly created Leaflet marker instances.
     */
    mod.renderSpikeZoneMarkers = function (map, zones, existingMarkers) {
        // Remove any previously rendered spike zone markers first.
        if (existingMarkers && existingMarkers.length > 0) {
            existingMarkers.forEach(function (m) {
                try { map.removeLayer(m); } catch (e) { /* ignore */ }
            });
        }

        var markers = [];
        if (!map || !zones || zones.length === 0) return markers;

        zones.forEach(function (zone) {
            if (!zone || typeof zone.lat !== 'number' || typeof zone.lon !== 'number') return;

            var icon = makeSpikeZoneIcon(zone.sev || 0);
            var marker = L.marker([zone.lat, zone.lon], { icon: icon, zIndexOffset: 1000 });
            marker.bindPopup(buildSpikeZonePopup(zone), { maxWidth: 280 });
            marker.addTo(map);
            markers.push(marker);
        });

        return markers;
    };

}(window.GpxFixMap = window.GpxFixMap || {}));
